<!-- App.vue -->
<template>
    <div>
        <CCol sm="12" xs="6" class="text-right">
            <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                <span style="margin-top:20px">Capture Detail</span>
            </h5>
    
        </CCol>
        <CCol sm="12" class="mt-5">
    
            <CCard class="m-2 b-20">
                <CRow>
                    <div style="width:30%">
                        <div class="m-2">
                            <img class="ml-3" style="max-width:80%" src="../assets/img/img2.png" />
                        </div>
                    </div>
                    <div style="width:70%">
                        <div class="ml-2 mt-4">
                            <h1 class="custom-14px">Broken Wall Dirty</h1>
                            <img class="size16px" src="../assets/img/fix.png" /> <label class="custom-12px">Can fixed</label>
                        </div>
                    </div>
                    <hr />
                    <div class="m-4">
                        <h3 class="custom-12px-600">Findings</h3>
                        <p class="custom-12px">Multiple vertical cracks observed on the interior wall near the northeast corner. One significant horizontal crack extends from the baseboard to the ceiling.</p>
    
                        <h3 class="custom-12px-600">Recommendation : </h3>
                        <p class="custom-12px">Further investigation needed to assess the cause and extent of the cracks with Genie Helper.</p>
    
                        <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToWishes()">Find</CButton>
                        <div class="text-center mt-3">
                            <label class="text-center mr-2">Capture Again</label><img style="max-width:16px" src="../assets/img/Scan.png" />
                        </div>
                    </div>
    
                </CRow>
    
            </CCard>
        </CCol>
    
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            videoStream: null,
            isLanguagePopupVisible: false,
        };
    },
    methods: {
        async startCamera() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                this.$refs.video.srcObject = stream;
                this.videoStream = stream;
            } catch (error) {
                console.error('Error accessing camera:', error);
            }
        },
        takePicture() {
            const video = this.$refs.video;
            const canvas = this.$refs.canvas;
            const context = canvas.getContext('2d');

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            // You can now access the image data in the canvas and send it to the server or perform other actions.

            // Stop the video stream to release the camera.
            this.videoStream.getTracks().forEach(track => track.stop());

            this.isLanguagePopupVisible = true;
        },
        GoToSelected() {
            // Show the popup and backdrop
            this.isLanguagePopupVisible = true;
        },
        closePopup() {
            this.isLanguagePopupVisible = false;
        },
        GoToWishes()
        {
            this.$router.push("Wishes");
        }
    },
};
</script>
  
<style>
/* Add your styles here if needed */
</style>
  